import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


import { servicesData } from "../data/servicesData";
import partnersData from "../data/partnersData";
import projectsData from "../data/projectsData";
import standardsData from "../data/standardsData";

import "./HomeStyle.css";

import banner1 from "../assets/banner/hero1.png";
import banner2 from "../assets/banner/hero1.png";
import banner3 from "../assets/banner/hero1.png";

// Import slick styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ✅ At the top of the file
import {
  FaCloud,
  FaRobot,
  FaChartLine,
  FaIndustry,
  FaCogs,
  FaLightbulb,
} from "react-icons/fa";
import { AiOutlineLineChart } from "react-icons/ai";
import { GiArtificialIntelligence } from "react-icons/gi";

function Home() {

const navigate = useNavigate();

  const truncateText = (t, limit = 200) =>
    t && t.length > limit ? t.substring(0, limit) + "..." : t;

  // ✅ Hero slide content
  const heroSlides = [
    {
      image: banner1,
      title: "Empowering Investments & Capital  Soar to Profits",
      description:"",
      buttonText: "",
      buttonLink: "/services",
    },
    {
      image: banner2,
      title: "focus on equity, shares, EOPs, bonds, and diversified financial instruments",
      description:"",
      buttonText: "",
      buttonLink: "/projects",
    },
    {
      image: banner3,
      title: "channels investor capital into high-growth opportunities across industries",
      description:"",
      buttonText: "",
      buttonLink: "/team",
    },
  ];

  // ✅ Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true,
  };


  const [projects, setProjects] = useState([]);
  const [pageInfo, setPageInfo] = useState({ title: "", description: "", footnote: "" });

const fetchData = async () => {
  try {
    const response = await fetch('https://goke.in/api/projects');
    const data = await response.json();

        setPageInfo(data.page || {});
        const projects = data.lists || [];
        setProjects(projects);
    console.log(data);
    // Do something with the data
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  useEffect(() => {
    fetchData();
  }, []);

  const getProjectImage = (proj) => {
    if (proj.images && typeof proj.images === "object") {
      if (proj.primary_image && proj.images[proj.primary_image]) {
        return proj.images[proj.primary_image];
      }
      const firstImage = Object.values(proj.images).find((url) => !!url);
      if (firstImage) return firstImage;
    }
    return proj.image || null;
  };

  return (
    <div className="home-container">
      {/* ✅ Hero Section (Dynamic Carousel) */}
      <section className="hero-slider">
        <Slider {...sliderSettings}>
          {heroSlides.map((slide, index) => (
            <div key={index} className="hero-slide">
              <img src={slide.image} alt={`Slide ${index + 1}`} className="hero-image" />
              <div className="hero-overlay">
                <h1 className=" w3-lineheight-90 w3-uppercase">{slide.title}</h1>
                <p>{slide.description}</p>
                <Link to={slide.buttonLink} className="w3-hide hero-btn">
                  {slide.buttonText}
                </Link>
              </div>
            </div>
          ))}
        </Slider>
      </section>




      {/* ✅ Highlighta */}
      <section className="snapshot-section alt-bg">
        <header className="work-header w3-center">
        
          
        <h1 className="w3-700 w3-text-gray w3-uppercase ">
        long-term
investments with  kindness in
our hearts and profits on our minds
        </h1>
      </header>
      </section>

      {/* ✅ Services Snapshot */}
      <section id="services" className="snapshot-section">

   <h1  className="w3-700 w3-text-gray w3-uppercase "> Empowering Investments to Soar </h1>

GÖKÇE  CAPITAL INVESTMENTS <br /> A visionary holding company dedicated to strategic investment portfolio management. With a focus on equity holdings across diverse sectors, GÖKÇE acts as a financial catalyst — distributing investor capital through shares, bonds, private equity options , and other instruments to fuel growth and maximize returns across industries.

       
        <div className="snapshot-grid">
          {servicesData.slice(0, 4).map((service) => (
            <div key={service.id} className="snapshot-card">
              <img src={service.image} alt={service.title} className=" w3-hide"/>
              <h3 className="w3-600">{service.title}</h3>
              <p>{service.description.substring(0, 100)}...</p>
            </div>
          ))}
        </div>

        <Link to="/services" className="w3-teal view-more-btn">
          →
        </Link>

      </section>


      {/* ✅ Highlighta */}
      <section className="snapshot-section alt-bg">
        <header className="work-header w3-center">
        
          
        <h1 className="w3-700 w3-text-gray w3-uppercase ">
        Vision
        </h1>
        <p className="">
        To be the most trusted and dynamic investment holding company, enabling capital to transform into enduring growth and innovation across industries.
        </p>

      </header>
      </section>





      {/* ✅ Highlighta */}
      <section className="snapshot-section">
        <header className="work-header w3-center">
     
         <h1 className="w3-700 w3-text-gray w3-uppercase ">
        Mission
        </h1>
        <p className="">
       To strategically manage diversified portfolios that maximize investor value.

To empower startups and established companies alike through capital, governance, and growth guidance.

To ensure every investment “flies like GOKÇE” — rising, evolving, and achieving sustainable success.
        </p>
      </header>
      </section>



      {/* ✅ Highlighta */}
      <section className="snapshot-section alt-bg">
        <header className="work-header w3-center">
        
        <h1 className="w3-700 w3-text-gray w3-uppercase ">" expertise in structuring private equity corporate bonds and financial instruments"
        </h1>
      </header>
      </section>



      {/* ✅ Projects Snapshot */}
      <section className="snapshot-sectionw w3-hide ">
        
        <header className="work-header w3-center">
          <h1 className="w3-700 w3-text-gray w3-uppercase ">Key Portfolio Holdings
        </h1>
      </header>


      {/* Projects Grid */}
      <div className="w3-row-padding work-grid">
        {projects.length > 0 ? (
          projects.slice(0, 8).map((proj) => {
            const img = getProjectImage(proj);
            return (
              <div key={proj.id} className="w3-col l3 m6 s12 w3-margin-bottom">

                <div  onClick={() => navigate(`/projects/${proj.id}`)}
                  className="w3-hover w3-pointer w3-cursor w3-card w3-padding w3-hover-shadow job-card"
                  style={{ height: "" }}
                >
                  {img && (
                    <img
                      src={img}
                      alt={proj.title}
                      className="w3-image w3-round-large"
                      style={{
                        width: "100%",
                        height: "",
                        objectFit: "cover",
                        marginBottom: "10px",
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="w3-center w3-padding">
            <p>No projects found for selected filters.</p>
          </div>
        )}
      </div>

        <Link to="/projects" className="view-more-btn">
          Portfolio →
        </Link>
      </section>

      {/* ✅ Partners Snapshot */}
      <section className="snapshot-section w3-hide">
        <h2  className=" w3-uppercase ">partnering with leaders to deliver excellence</h2>
        <p> </p>
        <div className="partners-grid">
          {partnersData.slice(0, 4).map((partner) => (
            <div key={partner.id} className="partner-card">
              <img src={partner.logo} alt={partner.name} />
               {partner.name.substring(0, 100)}
            </div>
          ))}
        </div>
        <Link to="/partners" className="view-more-btn">
          Partners →
        </Link>
      </section>

      {/* ✅ Standards Snapshot */}
      <section className="snapshot-section w3-hide">
        <h2  className=" w3-uppercase ">
        ensuring safety & quality global standards </h2>
        <p> </p>
        <div className="partners-grid">
          {standardsData.slice(0, 4).map((standards) => (
            <div key={standards.id} className="partner-card">
              <img src={standards.logo} alt={standards.name} />
               {standards.name.substring(0, 100)}
            </div>
          ))}
        </div>
      </section>


      {/* ✅ CTA Section */}
      <section className="cta-section">
        <h1  className="w3-700 w3-uppercase ">Let’s collaborate to build investment portfolio and  ecosystems that empowers innovation and profitability.</h1>
        <Link to="/home" className="cta-btn">
         Talk to an Expert
        </Link>
      </section>
    </div>
  );
}

export default Home;
